import script from "./MainSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSelect.vue?vue&type=script&setup=true&lang=js"

import "./MainSelect.vue?vue&type=style&index=0&id=45182ea2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45182ea2"]])

export default __exports__